var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 161,
    viewBox: "0 0 162 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_141_11064)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_141_11064)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.6309,
    y: 11.6309,
    width: 114.74,
    height: 114.74,
    rx: 5.737,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8692 55.5636C69.0809 54.3518 69.9444 52.8362 70.369 51.1759C70.7936 49.5156 70.7638 47.7716 70.2827 46.1268C69.8015 44.4819 68.8867 42.9968 67.6342 41.8271C66.3817 40.6574 64.8376 39.8461 63.1638 39.4784C61.49 39.1106 59.748 39.1999 58.1205 39.7369C56.4931 40.2739 55.04 41.2388 53.9137 42.5305C52.7874 43.8222 52.0293 45.393 51.7189 47.0784C51.4085 48.7639 51.5571 50.5017 52.1493 52.1099C44.6717 64.9978 46.4516 81.7826 57.4856 92.8167L57.5547 92.8858L63.8757 86.5648L63.8067 86.4957C56.1347 78.8253 54.554 67.3704 59.0615 58.1386C60.6277 58.4839 62.2557 58.429 63.7951 57.979C65.3345 57.5289 66.7356 56.6982 67.8692 55.5636Z",
    fill: "#F78613"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5566 92.8874C66.933 102.212 80.4296 104.882 92.1641 100.897L84.7716 93.5043C80.9896 94.0416 77.1346 93.6948 73.5092 92.491C69.8839 91.2872 66.5871 89.2592 63.8777 86.5664L57.5566 92.8874Z",
    fill: "#FBB945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.651 79.6502C101.607 79.1051 99.4393 79.254 97.4888 80.0737C95.5383 80.8934 93.915 82.3374 92.8738 84.1791C91.8325 86.0209 91.4321 88.1563 91.7354 90.2502C92.0387 92.3441 93.0286 94.2781 94.5497 95.7487C96.0707 97.2193 98.037 98.1433 100.14 98.3759C102.243 98.6084 104.364 98.1362 106.169 97.0334C107.975 95.9306 109.363 94.2595 110.117 92.2825C110.87 90.3054 110.946 88.1341 110.332 86.1094C117.945 73.2199 116.232 56.3483 105.196 45.25L98.8754 51.571C106.43 59.1852 108.022 70.4843 103.653 79.6502H103.651Z",
    fill: "#03AF89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1895 37.1946L77.5353 44.5405C81.3949 43.9425 85.3412 44.2678 89.0507 45.4897C92.7602 46.7115 96.1273 48.7953 98.8758 51.5699L105.197 45.2489L105.128 45.1798C95.6792 35.7328 82.0123 33.0695 70.1895 37.1946Z",
    fill: "#1AD3BB"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_141_11064",
    x: 0.682859,
    y: 0.156859,
    width: 160.636,
    height: 160.636,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11.474
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.474
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_141_11064"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_141_11064",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_141_11064"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.6309,
    y: 11.6309,
    width: 114.74,
    height: 114.74,
    rx: 5.737,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsvg);
export default __webpack_public_path__ + "static/media/icon.svg.044cfe30e6d80c5e514dcffbd3abab0b.svg";
export { ForwardRef as ReactComponent };